// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import MainLayout from "./components/layout/MainLayout";
// import { routes } from "./routes";
// import LoginPage from "./loginPage/LoginPage";
// import { Provider } from "react-redux";

// function App() {


  
//   return (
//     <BrowserRouter>
//         <Routes>
//           {/* <Route path="/" element={<LoginPage />}></Route> */}
//           <Route path="/" element={<MainLayout />}>
//             {routes}
//           </Route>
//         </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;


import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import { routes } from "./routes";
import LoginPage from "./loginPage/LoginPage";
import { Provider } from "react-redux";
import { useEffect } from "react";
import { migrateToEncryptedStorage } from "./utils/migrateData";

function App() {
  useEffect(() => {
    // Migrate existing data to encrypted format
    migrateToEncryptedStorage();
  }, []);

  return (
    <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />}></Route>
          <Route path="/" element={<MainLayout />}>
            {routes}
          </Route>
        </Routes>
    </BrowserRouter>
  );
}

export default App;
